import React from 'react';
import { Modal } from 'reactstrap';
import { QuotaTransferDetails } from '../../models/paymentsModel';
import AdminListGroup from '../admin/AdminListGroup';
import useModalState from '../../hooks/useModalState';

export interface Props {
  transactionDetail: QuotaTransferDetails;
}
const TransferDetailsCard: React.FC<Props> = ({transactionDetail}) => {
  const [showVoucher, toggleVoucherModal] = useModalState();

  const transferStatusMapper = (status: string) => {
    const statuses = {
      "approved": "Aprobada",
      "rejected": "Rechazada",
      "pending": "Pendiente",
    };

    return statuses[status as keyof typeof statuses] ?? "Desconocido";
  };

  const fieldMapper = [
    {
      "title": "Nombre del depositante",
      "value": transactionDetail.name,
    },
    {
      "title": "Documento de identificación",
      "value": transactionDetail.document,
    },
    {
      "title": "Referencia",
      "value": transactionDetail.identifier,
    },
    {
      "title": "Estado de transferencia",
      "value": transferStatusMapper(transactionDetail.status),
    },
    {
      "title": "Imagen del voucher",
      "value": transactionDetail.voucher_url
        ? (
          <img
            src={transactionDetail.voucher_url}
            alt="Voucher"
            onClick={() => toggleVoucherModal()}
            style={{
              height: 60,
              width: 60,
              objectFit: 'cover',
              borderRadius: 4,
              border: '1px solid #e9ecef',
              cursor: 'pointer',
            }}
          />
        )
        : 'No disponible',
    },
  ]

  return (
    <>
      <AdminListGroup title={"Detalle de la transferencia"} items={fieldMapper} />
      {transactionDetail.voucher_url && (
        <Modal
          className="modal-dialog-centered"
          isOpen={showVoucher}
          toggle={() => toggleVoucherModal()}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-voucher">
              Voucher de transferencia
            </h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => toggleVoucherModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body text-center">
            <img
              src={transactionDetail.voucher_url}
              alt="Voucher"
              style={{ maxWidth: '100%' }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default TransferDetailsCard